import React, { useCallback, useMemo } from 'react';
import { Selector } from './Selector/Selector';
import { useSettings } from '../../../../providers/SettingsProvider';
import { useTexts } from '../../../../useTexts';
const rates = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
export const useGetPlaybackRateText = () => {
  const {
    normalSpeed
  } = useTexts();
  return useCallback(rate => rate === 1 ? normalSpeed : String(rate), [normalSpeed]);
};
const useOptions = () => {
  const getPlaybackRateText = useGetPlaybackRateText();
  return useMemo(() => rates.map(value => ({
    displayText: getPlaybackRateText(value),
    value
  })), [getPlaybackRateText]);
};
export const SpeedSelector = _ref => {
  let {
    visible,
    onBackButtonClick
  } = _ref;
  const options = useOptions();
  const {
    menuSpeedTitle
  } = useTexts();
  const {
    playbackRate,
    setPlaybackRate
  } = useSettings();
  return /*#__PURE__*/React.createElement(Selector, {
    visible: visible,
    onBackButtonClick: onBackButtonClick,
    options: options,
    onSelect: setPlaybackRate,
    selectedValue: playbackRate,
    backButtonText: menuSpeedTitle
  });
};
//# sourceMappingURL=SpeedSelector.js.map